import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';
import Select2Init from 'select2/dist/js/select2';
window.jQuery = $;
window.$ = $;
Foundation.addToJquery();
Select2Init(window, $);
$.fn.select2.amd.define('select2/data/extended-ajax', ['./ajax', './tags', '../utils', 'module', 'jquery'], function (AjaxAdapter, Tags, Utils, module, $) {
    function ExtendedAjaxAdapter($element, options) {
        this.minimumInputLength = options.get('minimumInputLength');
        this.defaultResults = options.get('defaultResults');
        ExtendedAjaxAdapter.__super__.constructor.call(this, $element, options);
    }
    Utils.Extend(ExtendedAjaxAdapter, AjaxAdapter);
    let originQuery = AjaxAdapter.prototype.query;
    ExtendedAjaxAdapter.prototype.query = function (params, callback) {
        let defaultResults = (typeof this.defaultResults == 'function') ? this.defaultResults.call(this) : this.defaultResults;
        if ((defaultResults && defaultResults.length) && (!params.term || params.term.length < this.minimumInputLength) && (params._type && params._type == 'query')) {
            let data = { results: defaultResults };
            let processedResults = this.processResults(data, params);
            callback(processedResults);
        }
        else {
            originQuery.call(this, params, callback);
        }
    };
    if (module.config().tags) {
        return Utils.Decorate(ExtendedAjaxAdapter, Tags);
    }
    else {
        return ExtendedAjaxAdapter;
    }
});
